// alterado

import React, { useRef } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    inicializaEstudo,
    processaCalculoEstudo
} from '../estudo-form/EstudoServiceCalculo'

import {
    processaCenariosDefaultJsonUsuario,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    obtemPagina,
    paginas,
} from './EstudoReportService'

import {
    EstudoFormCenarios
 } from '../estudo-parametros/EstudoFormCenarios'

import EstudoReportPrimeiraReuniaoInputsInvestimento from './EstudoReportPrimeiraReuniaoInputsInvestimento'

import SimulacaoFinanceiraFormEvolucaoReservaFinanceira from '../simulacaoFinanceira-form/SimulacaoFinanceiraFormEvolucaoReservaFinanceira'

import EstudoReportContainer from './EstudoReportContainer'

import EstudoReportPage from './EstudoReportPage'

import EstudoReportPageCapa from './EstudoReportPageCapa'

import EstudoReportCapaPadrao from './EstudoReportCapaPadrao'

import EstudoReportDisclaimer from './EstudoReportDisclaimer'

import './EstudoReport.css'



const EstudoReportPrimeiraReuniaoInvestimento = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, vars }) => {

    let pagina = useRef(0)

    pagina.current = 0

    

    const estudo = useRef(null)

    useSingleton(() => {

        estudo.current = inicializaEstudo(/*vars.jsonConfiguracao*/)

        processaCenariosDefaultJsonUsuario(values, vars.jsonUsuario, vars.jsonUsuarioAdmin)
    })

    const report = true
    
    processaCalculoEstudo(values, handleSubmitAutomatico, estudo, report, true/*false*/,
        HARDCODE.origemCalculoEstudoPrimeiraReuniaoReport, /*true*/false, vars.jsonConfiguracao, false)



    return (

        <>
            <EstudoFormCenarios
                values={values}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
            />
            
            <EstudoReportContainer
                values={values}
                conteudo={
                    <>
                        <EstudoReportPageCapa
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            vars={vars}
                            conteudo={
                                <EstudoReportCapaPadrao
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                />
                            }
                        />

                        <EstudoReportPage
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            vars={vars}
                            cabecalho={LABEL.tabSimulacaoFinanceiraReportPrimeiraReuniaoInvestimento}
                            conteudo={
                                <>
                                    <br/>
                                    
                                    <EstudoReportPrimeiraReuniaoInputsInvestimento
                                        values={values}
                                    />
                                </>
                            }
                            pagina={obtemPagina(pagina)}
                        />

                        {paginas(estudo.current.evolucaoReservaFinanceiraReport,
                        HARDCODE.reportLinhasSemGraficoSemTotaisComRodape)?.map((item, ind) => (
                            <EstudoReportPage
                                key={ind}
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                cabecalho={LABEL.evolucaoReservaFinanceira}
                                conteudo={
                                    <>
                                        <SimulacaoFinanceiraFormEvolucaoReservaFinanceira
                                            values={values}
                                            estudo={estudo}
                                            report={true}
                                            popup={false}
                                            indInicial={item.indInicial}
                                            indFinal={item.indFinal}
                                        />
                                    </>
                                }
                                pagina={obtemPagina(pagina)}
                            />
                        ))}

                        <EstudoReportPage
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            vars={vars}
                            cabecalho={LABEL.disclaimer}
                            conteudo={
                                <EstudoReportDisclaimer
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    vars={vars}
                                />
                            }
                            pagina={obtemPagina(pagina)}
                        />
                    </>
                }
            />
        </>
    )
}

export default EstudoReportPrimeiraReuniaoInvestimento